/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Faq_4_QuestionInputs */

const en_svc_research_faq_4_question = /** @type {(inputs: Svc_Research_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can you show one running?`)
};

const lv_svc_research_faq_4_question = /** @type {(inputs: Svc_Research_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai varat parādīt, kā tas strādā?`)
};

/**
* | output |
* | --- |
* | "Can you show one running?" |
*
* @param {Svc_Research_Faq_4_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_faq_4_question = /** @type {((inputs?: Svc_Research_Faq_4_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Faq_4_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_faq_4_question(inputs)
	return en_svc_research_faq_4_question(inputs)
});